import { yup } from '@guiker/yup-util'

export const readArticlesBySlugQueryParams = yup.object({
  _embed: yup.boolean().default(true),
  per_page: yup.string(),
})
